import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import {
	FilterOperators,
	filterOperatorsText,
} from '../../Reports/reports.constants'
import { setCloudReportFilters } from '../../Reports/reports.slice'
import React from 'react'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { selectCloudReportFilters } from '../../Reports/reports.selectors'

const DynamicOperatorsHeaderFilter = ({ column }) => {
	const dispatch = useDispatch()
	const reportFilters = useSelector(selectCloudReportFilters)
	function RenderFilterOperationTypeInputs(filterOperationType) {
		switch (filterOperationType) {
			case FilterOperators.Equal:
			case FilterOperators.NotEqual:
			case FilterOperators.GreaterThan:
			case FilterOperators.GreaterThanOrEqual:
			case FilterOperators.LessThan:
			case FilterOperators.LessThanOrEqual:
                return (
                    <Input
                        placeholder={'Type here'}
                        value={reportFilters[`${column.dataField}`].filterValue ?? ''}
                        onChange={(e) => {
                            const amount = e.target.value
                            if (
                                isEmpty(amount) ||
                                (column.isDecimal && amount.match(/^\d+(\.\d{0,4})?$/)) ||
                                (!column.isDecimal && amount.match(/^\d+$/))
                            ) {
                                dispatch(
                                    setCloudReportFilters({
                                        ...reportFilters,
                                        [`${column.dataField}`]: {
                                            ...reportFilters[`${column.dataField}`],
                                            filterValue: isEmpty(amount) ? null : amount,
                                        },
                                    })
                                )
                            }
                        }}
                    />
                )
			case FilterOperators.Between:
			case FilterOperators.NotBetween:
				return (
					<>
                        <Input
                            placeholder={'Type here'}
							value={
								reportFilters[`${column.dataField}`].FilterValueAfter ?? ''
							}
							onChange={(e) => {
								const amount = e.target.value
								if (
									!amount ||
									(column.isDecimal && amount.match(/^\d+(\.\d{0,4})?$/)) ||
									(!column.isDecimal && amount.match(/^\d+$/))
								) {
									dispatch(
										setCloudReportFilters({
											...reportFilters,
											[`${column.dataField}`]: {
												...reportFilters[`${column.dataField}`],
												FilterValueAfter: isEmpty(amount) ? null : amount,
											},
										})
									)
								}
							}}
                        />
						<div className={'text-center'}>and</div>
                        <Input
                            placeholder={'Type here'}
							value={
								reportFilters[`${column.dataField}`].FilterValueBefore ?? ''
							}
							onChange={(e) => {
								const amount = e.target.value
								if (
									!amount ||
									(column.isDecimal && amount.match(/^\d+(\.\d{0,4})?$/)) ||
									(!column.isDecimal && amount.match(/^\d+$/))
								) {
									dispatch({
										...reportFilters,
										[`${column.dataField}`]: {
											...reportFilters[`${column.dataField}`],
											FilterValueBefore: isEmpty(amount) ? null : amount,
										},
									})
								}
							}}
                        />
					</>
				)
		}
	}

	return (
		<>
            <div style={{ paddingBottom: '10px' }}>
                <Select
                    value={reportFilters[`${column.dataField}`]?.filterOperationType ?? ''}
                    onValueChange={(val) => {
                        dispatch(
                            setCloudReportFilters({
                                ...reportFilters,
                                [`${column.dataField}`]: { filterOperationType: val },
                            })
                        )
                    }}
                >
                    <SelectTrigger className='w-full'>
                        <SelectValue placeholder='=' />
                    </SelectTrigger>
                    <SelectContent>
                        {Object.values(FilterOperators).map((operator) => (
                            <SelectItem key={operator} value={operator}>
                                {filterOperatorsText[operator]}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
			{RenderFilterOperationTypeInputs(
				reportFilters[`${column.dataField}`]?.filterOperationType
			)}
		</>
	)
}

export default DynamicOperatorsHeaderFilter
